var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-alert',{attrs:{"value":_vm.showAlert,"type":_vm.type,"role":"region","aria-label":_vm.ariaLabel,"icon":_vm.icon}},[(_vm.title)?_c('h2',[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.sanitize(_vm.message))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }